// extracted by mini-css-extract-plugin
export default {"yoti-circle":"yotiCircle_yoti-circle__dX2z5"};